import React, { useEffect } from 'react';
import { redirectToKeycloakPasswordReset } from '../service/adminUI';
import { useHistory } from 'react-router';

/**
 * ForgotPassword Component
 * Redirects to Keycloak's built-in password reset page
 */
const ForgotPassword = () => {
  const history = useHistory();

  useEffect(() => {
    // Redirect to Keycloak password reset page
    redirectToKeycloakPasswordReset();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <p>Redirecting to password reset page...</p>
      <button 
        onClick={() => history.push('/login')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#25BDBD',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Back to Login
      </button>
    </div>
  );
};

export default ForgotPassword;

